/**
 * YunExpress answers a refused booking in Chinese, and the desk read it as is (SSD-7512). The refusals seen so far get
 * an English line; the carrier's own text always stays beside it, because that is what YunExpress support asks for and
 * a refusal not listed here still has to be readable by someone. An error or a timeout may still have made a waybill
 * (Facade CarrierFailure.isOutcomeUnknown), so those lines send the desk to YUN OMS before another booking.
 */
const KNOWN_CARRIER_ERRORS: ReadonlyArray<{ pattern: RegExp; english: string }> = [
  {
    // "IOSS号 IM2330038248 未备案，请先备案"
    pattern: /IOSS\s*号?.*未备案/,
    english:
      'YunExpress has no registered IOSS number for this EU destination, so it will not take the parcel. Ask YunExpress to register it, then book again.',
  },
  {
    // "接口异常，请稍后重试或联系客服人员"
    pattern: /接口异常/,
    english:
      'YunExpress had an API error, usually for a few minutes. It may still have made the waybill: search SKINSEOUL_ and the order number in YUN OMS before booking again.',
  },
  {
    // "服务执行超时". Only this wording: a timeout leaves the outcome unknown, so the line never says to book again blind.
    pattern: /服务执行超时/,
    english:
      'YunExpress did not finish in time, so it may or may not have made the waybill. Search SKINSEOUL_ and the order number in YUN OMS before booking again.',
  },
];

/** The English line for a carrier refusal the desk has met before, or null when it is not one of them. */
export const explainCarrierError = (message: string | null | undefined): string | null => {
  if (!message) {
    return null;
  }
  return KNOWN_CARRIER_ERRORS.find(({ pattern }) => pattern.test(message))?.english ?? null;
};

/** One line for a toast or a sentence: the English first, the carrier's own words after it; unchanged when unknown. */
export const withCarrierExplanation = (message: string): string => {
  const english = explainCarrierError(message);
  return english ? `${english} YunExpress said: ${message}` : message;
};
